import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';

@Component({
  selector: 'app-view-item',
  templateUrl: './view-item.component.html',
  standalone: true,
  imports: [CommonModule, NzInputModule, NzToolTipModule],
  styles: []
})
export class ViewItemComponent {
  @Input() text: string = '';
  @Input() class: string = '';
  @Input() borderless = false;
  
  @Input() tabindex:string | null = null;
  constructor() {}

  onClick(e: any) {
    if (!window.getSelection()?.toString()) {
      e.select();
    }
  }
}
